__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = function(name, initScope) {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = function(msg) { return typeof console !== "undefined" && console.warn && console.warn(msg); };
	var uniqueName = "live-casino";
	var register = function(name, version, factory, eager) {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = function(id) {
		var handleError = function(err) { warn("Initialization of sharing external failed: " + err); };
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = function(module) { return module && module.init && module.init(__webpack_require__.S[name], initScope); }
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@modulor/react", "1.70.2", function() { return Promise.all([__webpack_require__.e(2142), __webpack_require__.e(3462), __webpack_require__.e(8416), __webpack_require__.e(1051), __webpack_require__.e(3366)]).then(function() { return function() { return __webpack_require__(33462); }; }); });
			register("big-brother", "1.15.0", function() { return Promise.all([__webpack_require__.e(1434), __webpack_require__.e(9575)]).then(function() { return function() { return __webpack_require__(81434); }; }); });
			register("react-dom", "18.2.0", function() { return Promise.all([__webpack_require__.e(4164), __webpack_require__.e(8416)]).then(function() { return function() { return __webpack_require__(54164); }; }); });
			register("react-query", "3.39.3", function() { return Promise.all([__webpack_require__.e(1933), __webpack_require__.e(8416), __webpack_require__.e(1051), __webpack_require__.e(9762)]).then(function() { return function() { return __webpack_require__(91933); }; }); });
			register("react-router-dom", "5.3.4", function() { return Promise.all([__webpack_require__.e(9678), __webpack_require__.e(350), __webpack_require__.e(8416)]).then(function() { return function() { return __webpack_require__(60350); }; }); });
			register("react", "18.2.0", function() { return __webpack_require__.e(2791).then(function() { return function() { return __webpack_require__(72791); }; }); });
			register("redux-saga", "1.3.0", function() { return Promise.all([__webpack_require__.e(9221), __webpack_require__.e(5792)]).then(function() { return function() { return __webpack_require__(95792); }; }); });
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(function() { return initPromises[name] = 1; });
};